const SimpleTickBox = ({  
  id,
    label,
    checked,
    onChange,
    disabled = false,
    required = false 

}) => {
  return (
    <div className="flex items-center">
      <input

        type="checkbox"
        id={id}
        name={id}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="mr-2 h-4 w-4"
        required={required}
        value={label}
      />
      <label htmlFor={id} className="cursor-pointer">
        {label}
      </label>
    </div>
  );
};

export default SimpleTickBox;
